<template>
  <div>
    <spinner-round :isLoading="loadRdv" v-if="loadRdv"></spinner-round>
    <div v-else>
      <div class="has-bg-annonce columns is-vcentered" v-if="isExported && !googleLogged">
        <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="icon has-text-white"><i class="fas fa-engine-warning fa-lg"></i></span>
        </div>
        <div class="column is-paddingless-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <div class="has-text-white is-italic is-size-6">
            <span>Ce rendez-vous est lié au compte Google de l'utilisateur : {{rdv.exported_by_name}}.</span>
            <span>Pour le modifier vous devez vous <a @click="makeGoogleLogin" class="is-underline has-text-white is-italic"> connecter à votre compte Google agenda</a>. Si le calendrier de l'utilisateur est partagé avec le votre vous pourrez enregistrer vos modifications.</span>
          </div>
        </div>
      </div>
      <div class="is-border-bottom has-bg-grey3">
        <div v-if="!isSeller" class="column">
          <span class="label"></span>
          <input id="selfRdv" type="checkbox" name="selfRdv"
                  class="switch is-success is-rounded" v-model="selfRdv">
          <label for="selfRdv" class="label">
            <span class="is-size-6 has-text-grey">Ce rendez est pour moi</span>
          </label>
        </div>
        <div v-if="!isSeller && !selfRdv" class="column is-paddingless-top">
          <label for="" class="label">Utilisateur *</label>
          <multiselect v-model="seller" label="email" track-by="pk"
                        :custom-label="sellerName"
                        v-validate="'required'"
                        name="user"
                        class="multiselect--option-ico"
                        :placeholder="''"
                        data-vv-as="Utilisateur"
                        :options="users" :searchable="true" :close-on-select="true" :show-labels="false"
                        @search-change="getUsers">
            <span slot="placeholder" class="multiselect__placeholder">Sélectionnez ou saisissez un utilisateur</span>
            <span slot="noOptions">La liste est vide</span>
          </multiselect>
          <p v-if="errors.has('user')" class="help is-danger">
            {{errors.first('user')}}
          </p>
        </div>
      </div>
      <div class="column is-12 is-paddingless is-padding-top has-bg-light">
        <label class="label is-padding-left">Type de rendez-vous</label>
        <div class="column is-12 columns is-variable is-1 is-multiline is-paddingless-top is-paddingless-bottom">
          <div class="column is-6 is-paddingless-top is-paddingless-left" style="padding-bottom: var(--columnGap)">
            <input id="R0-quick" v-model="rdv_type" value="R0" name="typeRdv" @input="changeType('R0')" @click="changeType('R0')"
                    checked="checked" class="checkradiocase is-primary is-fullwidth" type="radio">
            <label for="R0-quick">R0</label>
          </div>
          <div class="column is-6 is-paddingless-top is-paddingless-left" style="padding-bottom: var(--columnGap)">
            <input id="R1-quick" v-model="rdv_type" value="R1" name="typeRdv" @input="changeType('R1')" @click="changeType('R1')"
                    checked="checked" class="checkradiocase is-primary is-fullwidth" type="radio">
            <label for="R1-quick">R1</label>
          </div>
          <div class="column is-6 is-paddingless-top is-paddingless-left" style="padding-bottom: var(--columnGap)">
            <input id="R2-quick" v-model="rdv_type" value="R2" name="typeRdv" @input="changeType('R2')" @click="changeType('R2')"
                    checked="checked" class="checkradiocase is-primary is-fullwidth" type="radio">
            <label for="R2-quick">R2</label>
          </div>
          <div class="column is-6 is-paddingless-top is-paddingless-left" style="padding-bottom: var(--columnGap)">
            <input id="R3-quick" v-model="rdv_type" value="R3" name="typeRdv" @input="changeType('R3')" @click="changeType('R3')"
                    checked="checked" class="checkradiocase is-primary is-fullwidth" type="radio">
            <label for="R3-quick">R3</label>
          </div>
        </div>
      </div>
      <div class="column is-paddingless-bottom has-bg-light">
        <label class="label">Date du rendez-vous</label>
        <div class="field has-addons">
          <div class="control">
            <a class="button is-square is-static is-border is-min-width-0">
              <span class="icon"><i class="fal fa-calendar-alt"></i></span>
            </a>
          </div>
          <div class="control is-expanded has-icons-right">
            <flat-pickr v-validate="'required'" @input="checkDate(date)"
                        :class="{'is-danger': errors.has('date')}"
                        :config="configDate" v-model="date" class="input is-radiusless" name="date">
            </flat-pickr>
            <p v-if="errors.has('date')" class="help is-danger">{{errors.first('date')}}</p>
          </div>
          <div class="control">
            <a class="button is-square is-radiusless" @click="deleteDate">
              <i class="fal fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="columns is-border-bottom is-padding-bottom has-bg-light">
        <div class="column is-6 is-paddingless-bottom">
          <label class="label">Heure début</label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-square is-static is-border is-min-width-0">
                <span class="icon"><i class="fal fa-clock"></i></span>
              </a>
            </div>
            <div class="control is-expanded has-icons-right">
              <flat-pickr @input="checkHour(hourStart)" id="hourStart"
                          :config="configHour" v-model="hourStart" class="input is-padding-xsmall is-radiusless" name="hourStart">
              </flat-pickr>
            </div>
            <div class="control">
              <a class="button is-square is-radiusless" @click="deleteHour('hourStart')">
                <i class="fal fa-times"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="column is-6 is-paddingless-bottom">
          <label class="label">Heure fin</label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-square is-static is-border is-min-width-0">
                <span class="icon"><i class="fal fa-clock"></i></span>
              </a>
            </div>
            <div class="control is-expanded has-icons-right">
              <flat-pickr @input="checkHour(hourEnd)" id="hourEnd"
                          :config="configHour" v-model="hourEnd" class="input is-padding-xsmall is-radiusless" name="hourEnd">
              </flat-pickr>
            </div>
            <div class="control">
              <a class="button is-square is-radiusless" @click="deleteHour('hourEnd')">
                <i class="fal fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="is-border-bottom" v-if="!contact">
        <div class="column is-paddingless-bottom" v-if="totalContact > 0 && !formContact">
          <label for="" class="label">Séléctionner un contact</label>
            <multiselect v-model="contact" label="contact" track-by="pk"
                      name="contact"
                      class="multiselect--option-ico"
                      :placeholder="''"
                      :custom-label="contactName"
                      data-vv-as="Séléctionner un contact"
                      :options="contacts" :searchable="true" :close-on-select="true" :show-labels="false"
                      @search-change="getContacts">
            <span slot="placeholder" class="multiselect__placeholder">Sélectionnez ou saisissez un contact</span>
          </multiselect>
        </div>
        <div v-if="totalContact !== null && totalContact === 0 && !contact" class="column is-narrow is-paddingless-top is-padding-right-xsmall">
          <div class="column is-12 is-paddingless-bottom">
            <div class="notification is-warning is-radius is-size-6 is-padding-top-small is-padding-bottom-small">
              <p>Ce vendeur ne possède pas de contact actuellement.</p>
            </div>
          </div>
        </div>
        <div class="column is-narrow is-padding-top is-padding-right-xsmall">
          <button @click="formContact = !formContact" class="button is-light has-text-grey is-border is-full is-rounded is-padding-right-large is-padding-left-large">
            <span v-if="!formContact" class="is-transform-none">Créer un nouveau contact</span>
            <span v-else class="is-transform-none">Annuler nouveau contact</span>
          </button>
          <div v-if="formContact" class="is-padding-top">
            <contact-form ref='contact_form' @submit="submitContactResponse" :fromQuickview='true' @iCanSubmit="iCanSubmitContact"></contact-form>
            <div class="is-padding-top">
              <button @click="submitContact" class="button is-success is-full has-text-white" :disabled="!canSubmitContact">
                <span v-if="isLoadingContact"><i class="fas fa-spinner fa-spin"></i></span>
                <span v-else>Créer contact</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="is-border-bottom" v-else>
        <div class="column is-12 is-padding-top-small is-paddingless-bottom">
          <span class="label">Contact</span>
        </div>
        <div class="column is-12">
          <div class="columns is-gapless">
            <div class="column is-9 is-vcentered columns">
              <avatar :item="contact" :usePicto="'contact'"></avatar>
              <div class="is-margin-left-small">
                <div class="title is-4">
                  <b>{{contact.last_name}} {{contact.first_name}}</b>
                  <div class="is-size-5" v-if="contact.address && contact.address.zip_code">
                    {{contact.address.line1 || ''}} {{contact.address.zip_code || ''}} {{contact.address.city || ''}}
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-3 has-text-right actions">
              <a class="button is-circle" @click="contact = null">
                <i class="fal fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="columns is-multiline">
          <div class="column is-12 is-padding-top is-paddingless-bottom" v-if="contact">
            <input id="adressContact" name="adressContact" class="switch is-success is-rounded is-medium" type="checkbox"
                    v-model="selectContactAddress">
            <label for="adressContact" class=""><span class="is-size-5">Rendez-vous à l'adresse du contact</span></label>
          </div>
          <div class="column is-12 columns is-vcentered is-paddingless">
            <div class="column is-paddingless-top is-paddingless-left">
              <gmap-input :source="address" @submit="updateAddress" :label="''" :placeholder="'indiquer le lieu du rendez-vous'" :fromQuickview="true" :onlyInput="true"></gmap-input>
            </div>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-paddingless-top">
            <label for="" class="label">Inviter utilisateur</label>
            <multiselect v-model="guests" label="guests" track-by="pk"
                          :custom-label="sellerName"
                          name="guests"
                          :multiple="true"
                          class="multiselect--option-ico"
                          :placeholder="''"
                          data-vv-as="Invite"
                          :options="allGuests" :searchable="true" :close-on-select="true" :show-labels="false"
                          @search-change="getGuests">
              <span slot="placeholder" class="multiselect__placeholder">Sélectionnez ou saisissez un invité</span>
              <span slot="noOptions">La liste est vide</span>
            </multiselect>
            <p v-if="errors.has('guests')" class="help is-danger">
              {{errors.first('guests')}}
            </p>
          </div>
        </div>
        <div class="columns is-multiline is-border-top has-bg-light">
          <div class="column is-12 is-padding-top-small is-padding-bottom-small">
            <label for="rdvNote" class="label">Ajouter Note :</label>
          </div>
          <div class="column is-12 is-paddingless-top">
            <div class="field" @mouseover="displayToolbar = true" @mouseleave="displayToolbar = false">
              <div class="control">
                <wysiwyg-editor :model="rdv.note" placeholder="" :light='true'
                                @change="val => updateNote(val)"
                                :class="{'editr--hide-toolbar':!displayToolbar}"
                                class="editr--bottom-toolbar editr--height-small content has-bg-white"/>
              </div>
            </div>
            <p v-if="noteError" class="help is-danger">Maximum 255 charactères dans le champs note</p>
          </div>
        </div>
      </div>
      <div v-if="rdvReady"></div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { isNil, debounce } from 'lodash'
  import moment from 'moment'
  import { DefaultValues, GoogleMx } from '@/mixins'
  import ContactForm from '@/components/contact/ContactForm'

  const emptyRdv = Object.freeze({
    rdv_type: 'R0',
    address: {},
    guests: [],
    date: null,
    seller: null,
    note: null,
    end_date: null,
    contact: null
  })

  export default {
    name: 'CalendarQuickviewForm',
    components: {
      ContactForm
    },
    mixins: [DefaultValues, GoogleMx],
    props: {
      source: {
        type: Object,
        default: () => {}
      }
    },
    data () {
      return {
        displayToolbar: false,
        noteError: false,
        guest: null,
        guests: [],
        allGuests: [],
        guests_name: [],
        modifiedRdv: false,
        loadRdv: false,
        isLoadingContact: false,
        selectContactAddress: false,
        seller: null,
        canSubmitContact: false,
        totalContact: null,
        formContact: false,
        users: [],
        contacts: [],
        date: null,
        hourStart: '07:00',
        hourEnd: '08:00',
        configDate: {
          altInput: true,
          altFormat: 'j M Y',
          dateFormat: 'Z'
        },
        configHour: {
          enableTime: true,
          noCalendar: true,
          dateFormat: 'H:i',
          time_24hr: true
        },
        rdv: {},
        selfRdv: true,
        rdv_type: 'R0',
        contact: null,
        address: {}
      }
    },
    computed: {
      ...mapState(['currentUserPk', 'googleLogged']),
      ...mapGetters(['isAdmin', 'isManager', 'isSeller', 'isOperator']),
      rdvReady () {
        if (this.contact && (this.seller || this.selfRdv)) {
          this.iCanSubmit(true)
          return true
        } else {
          this.iCanSubmit(false)
          return false
        }
      },
      isExported () {
        let exported = isNil(this.rdv.google_event_id) === false && isNil(this.rdv.google_calendar_id) === false
        this.$emit('exported', exported)
        return exported
      },
      guestsPk () {
        return this.guests.map(x => x.pk)
      },
      excludesGuests () {
        if (this.sellerPk) {
          return this.guestsPk.concat(this.sellerPk)
        } else return this.guestsPk
      }
    },
    watch: {
      selfRdv (v) {
        this.seller = null
        this.contact = null
        if (v) this.deleteMeFromGuests()
      },
      selectContactAddress (v) {
        if (v) {
          this.$set(this.rdv, 'address', this.contact.address)
          this.$set(this, 'address', this.contact.address)
        } else {
          this.$set(this, 'address', null)
          this.$set(this.rdv, 'address', null)
        }
      }
    },
    methods: {
      updateNote (val) {
        this.$set(this.rdv, 'note', val)
        val.length > 255 ? this.noteError = true : this.noteError = false
      },
      deleteGuest (i) {
        this.guests.splice(i, 1)
        this.guests_name.splice(i, 1)
      },
      submit () {
        let startHour = document.querySelector('#hourStart').value
        startHour = startHour.split(':')
        let newDate = moment(this.date).set({'hour': startHour[0], 'minute': startHour[1]})
        this.date = newDate._d

        if (isNil(this.contact)) {
          this.$notify({
            type: 'is-danger',
            text: 'Vous devez indiquer le contact associé au rendez-vous.'
          })
          return
        }
        if (!this.selfRdv && isNil(this.seller)) {
          this.$notify({
            type: 'is-danger',
            text: 'Vous devez indiquer le vendeur associé au rendez-vous.'
          })
          return
        }
        this.$validator.validateAll().then((valid) => {
          if (valid) {
            let rdv = Object.assign({}, this.rdv)
            if (!this.selfRdv) {
              rdv.seller = this.seller.pk
            } else rdv.seller = this.currentUser.pk
            rdv.contact = this.contact.pk
            if (this.guests.length) {
              rdv.guests = this.guests.map(x => x.pk)
            } else {
              rdv.guests = []
              rdv.guests_email = []
              rdv.guests_name = []
            }
            rdv.rdv_type = this.rdv_type
            let endHour = document.querySelector('#hourEnd').value
            endHour = endHour.split(':')
            let newDateEnd = moment(this.date).set({'hour': endHour[0], 'minute': endHour[1]})
            rdv.end_date = newDateEnd._d
            rdv.end_date = moment.utc(rdv.end_date).format('DD/MM/YYYY HH:mm')
            rdv.date = this.date
            console.log(rdv)
            if (this.modifiedRdv) {
              this.$api.rdvService.put(rdv.pk, rdv).then(r => {
                this.$emit('submit', {rdv: r.data})
                this.$notify({
                  type: 'is-success',
                  text: 'Le rendez-vous a été modifié.'
                })
              }).catch(err => {
                console.log(err)
              })
            } else {
              this.$api.rdvService.post(rdv).then(r => {
                this.$emit('submit', {rdv: r.data})
                this.$notify({
                  type: 'is-success',
                  text: 'Le rendez-vous a été créé.'
                })
              }).catch(err => {
                console.log(err)
              })
            }
          } else {
            this.$notify({
              type: 'is-danger',
              text: 'Le formulaire est invalide.'
            })
          }
        })
      },
      submitContactResponse (val) {
        this.$api.contactService.post(val.contact).then(res => {
          this.contact = res.data
          this.isLoadingContact = false
          this.$notify({
            type: 'is-success',
            text: 'Le contact a été créé.'
          })
        }).catch(() => {
          this.isLoadingContact = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la création du contact.'
          })
        })
        this.contact = val.contact
      },
      submitContact () {
        this.$refs.contact_form.submit()
      },
      getContactsCount () {
        let query = {
          per_page: 1
        }
        if (this.seller) {
          query.seller = this.seller.pk
        }
        this.$api.contactService.get(query).then(r => {
          this.totalContact = r.data.total
        })
      },
      iCanSubmit (val) {
        this.$emit('iCanSubmit', val)
      },
      iCanSubmitContact (val) {
        this.canSubmitContact = val
      },
      updateAddress ({address, location}) {
        this.$set(this.rdv, 'address', address)
        this.$set(this, 'address', address)
      },
      changeType (val) {
        this.rdv_type = val
      },
      selectedDate: debounce(function (date) {
        this.date = date
        let splitHour = this.hour.split(':')
        let hTime = splitHour[0]
        let mTime = splitHour[1]
        hTime = Number(hTime)
        mTime = Number(mTime)
        let formatDate = moment(date).set({'hour': hTime, 'minute': mTime})
        this.date = formatDate._d
      }, 200),
      deleteDate () {
        this.date = null
      },
      deleteHour (val) {
        if (val) {
          this[val] = null
        } else {
          this.hourStart = null
          this.hourEnd = null
        }
        let newDate = moment(this.date).set({'hour': 7, 'minute': 0})
        this.date = newDate._d
      },
      checkDate (date) {
        if (date === null || date === '') this.preselectedDate = null
        this.date = date
        let formatDate = moment.utc(date).format('YYYY/MM/DD')
        if (this.preselectedDate !== formatDate) this.preselectedDate = null
      },
      checkHour (hour) {
        this.hour = hour
        let splitHour = hour.split(':')
        let hTime = splitHour[0]
        let mTime = splitHour[1]
        hTime = Number(hTime)
        mTime = Number(mTime)
        let newDate = moment(this.date).set({'hour': hTime, 'minute': mTime})
        this.date = newDate._d
      },
      sellerName (seller) {
        if (seller && seller.last_name) {
          let name = seller.first_name + ' ' + seller.last_name
          if (seller.company_name) {
            name = name + ' (' + seller.company_name + ')'
          }
          return name
        } else {
          return 'Selectionnez un vendeur'
        }
      },
      contactName (contact) {
        if (contact && contact.last_name) {
          return contact.first_name + ' ' + contact.last_name
        } else {
          return 'Selectionnez un Contact'
        }
      },
      getUsers (query = null) {
        let filters = {
          first_name: query
        }
        this.$api.userService.get(filters).then(r => {
          this.users = r.data.items
        })
      },
      getGuests (query = null) {
        let filters = {
          exclude: this.excludesGuests,
          first_name: query
        }
        this.$api.userService.get(filters).then(r => {
          this.allGuests = r.data.items
        })
      },
      getContacts (query = null) {
        let filters = {}
        if (query) {
          filters['first_name'] = query
        }
        if (this.seller) {
          filters['seller'] = this.seller.pk
        }
        filters['sort'] = 'first_name:asc'
        this.$api.contactService.get(filters).then(r => {
          this.contacts = r.data.items
        })
      },
      loadSellerContacts (seller) {
        let filters = {
          seller: seller.pk,
          per_page: 1
        }
        this.$api.contactService.get(filters)
          .then(res => {
            this.sellerContacts = res.data.total
            if (res.data.total > 0) {
              this.getContacts()
            }
          })
      }
    },
    async created () {
      this.loadRdv = true
      this.getGuests()
      this.getUsers()
      this.getContacts()
      this.getContactsCount()
      if (this.source) {
        console.log(this.source)
        this.modifiedRdv = true
        Object.assign(this.rdv, this.source)
        this.hourStart = new Date(this.source.date)
        this.hourEnd = new Date(this.source.end_date)
        this.date = new Date(this.source.date)
        let user = await this.$api.userService.getOne(this.source.seller)
        this.rdv_type = this.source.rdv_type
        if (user.data.pk === this.currentUser.pk) {
          this.selfRdv = true
          this.$nextTick(() => {
            this.$set(this, 'seller', Object.assign({}, user.data))
            this.$set(this.rdv, 'seller', Object.assign({}, user.data))
          })
        } else {
          this.selfRdv = false
          await this.loadSellerContacts(user.data)
          this.$nextTick(() => {
            this.$set(this, 'seller', Object.assign({}, user.data))
            this.$set(this.rdv, 'seller', Object.assign({}, user.data))
          })
        }
        let contact = await this.$api.contactService.getOne(this.source.contact)
        this.contact = contact.data
        if (this.source.guests && this.source.guests.length) {
          this.source.guests.forEach((guest, i) => {
            let guestPk = this.source.guests[i]
            let guestName = this.source.guests_name[i].split(' ')
            this.guests.push({
              pk: guestPk,
              first_name: guestName.shift(),
              last_name: [...guestName].join(' ')
            })
          })
        }
        let addressContact = null
        if (this.contact.address && 'address' in this.contact) {
          addressContact = this.contact.address.line1 + this.contact.address.zip_code + this.contact.address.city
        }
        let addressRdv = null
        if (this.source.address && 'address' in this.source) {
          addressRdv = this.source.address.line1 + this.source.address.zip_code + this.source.address.city
        }
        if (addressContact === addressRdv && addressContact && addressRdv) {
          this.selectContactAddress = true
        } else if (addressRdv) {
          this.address = addressRdv
        }
        this.loadRdv = false
      } else {
        this.configDate.minDate = 'today'
        Object.assign(this.rdv, emptyRdv)
        this.date = moment().add(1, 'day').hours(8).startOf('hour').toDate()
        this.$nextTick(() => {
          this.loadRdv = false
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/calendar/CalendarQuickviewForm.vue